<div class="dialog-outer">
    <div class="dialog-content">
        <div class="header" mat-dialog-title>
            {{'businessTexts.details' | translate}}
            <button mat-dialog-close class="close-btn" (click)="closeDialog()"
                matTooltip="{{'businessTexts.close' | translate}}">
                <cqes-icon icon="close" class="close-icon"></cqes-icon>
            </button>
        </div>
        
        <mat-dialog-content class="mat-typography con">
            <div class="details-wrapper">
                <div class="spinner-container" *ngIf="wait">
                    <div class="spinner">
                        <mat-spinner></mat-spinner>
                    </div>
                </div>
        
                <div *ngIf="!wait && pack" class="max-width">
        
                    <div class="row-container">

                        <div class="info-container">
                            <!-- Parcel title -->
                            <div class="word-break"><span class="label">{{'businessTexts.packageName' | translate}}:</span>
                                {{pack.name}}</div>
                       

                            <!-- Description -->
                            <div class="word-break"><span class="label">{{'businessTexts.shortDescription' | translate}}:</span>
                                {{pack.description}}
                            </div>

                            <!-- Date -->
                            <div><span class="label">{{'businessTexts.sentOn' | translate}}:</span> {{pack.ts |
                                date: dateFormat}}
                                {{getTimeAbbr()}} <span class="label">{{'sentenceParts.from' | translate}}</span> {{getSenderName()}}</div>
                        </div>

                        <!-- Registered mail download -->
                        <div class="details-registered-mail-information" *ngIf="data.isRegisteredMail">
                            {{'historyTexts.registeredMail' | translate}}
                            <cqes-icon class="details-register-mail-icon" (click)="onDownloadRegisteredMailReceipt(data)" icon="system_update_alt"></cqes-icon>
                        </div>

                    </div>
                    <mat-expansion-panel *ngIf="isBusinessProfile()">
                        <mat-expansion-panel-header class="header-panel">
                            <mat-panel-title>{{ 'businessTexts.packageOptions' | translate
                                }}</mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="package-settings txt">
                            <mat-checkbox color="primary" [(ngModel)]="pack.toBeArchived" disabled>
                                {{ 'businessTexts.packageToArchive' | translate }}
                            </mat-checkbox> <br>
                            <mat-checkbox color="primary" [(ngModel)]="!pack.notAvailableAfterSigning" disabled>
                                {{ 'businessTexts.packageAvailable' | translate }} </mat-checkbox>
                            <br>
                            <mat-checkbox color="primary" [(ngModel)]="pack.recepientPays" disabled>
                                {{ 'businessTexts.packageReceiversPay' | translate }}</mat-checkbox>
                            <br>
                            <div class="validity-section">
                                <span class="validity-title">{{ 'businessTexts.signerPeriod' |
                                    translate }}: </span>
                                <mat-select class="validity" placeholder="{{'signingTexts.validity' | translate}}"
                                    name="validity-period" [ngModel]="validity" disabled>
                                    <mat-option *ngFor="let p of periodsDictionary" [value]="p.value">
                                        {{p.key}} {{getUnitTranslation(p.key, p.unit)}}
                                    </mat-option>
                                </mat-select>
                            </div>
                            
                            <br>

                            <div class="in-copy" *ngIf="data?.parcelType === 'BATCH_SIGNING'">
                                <p>{{ 'businessTexts.inCopy' | translate }}: </p>
                                <span *ngIf="translateService.currentLang === 'bg'">{{recipientNamesCC.bg | async}}</span>
                                <span *ngIf="translateService.currentLang === 'en'">{{recipientNamesCC.en | async}}</span>
                            </div>
                            <br>
                            <!-- future implementation -->
                            <!-- <div class="reminder-section">
                                    <span>{{ 'businessTexts.singleSignerReminder' | translate }}: </span>
                                    <mat-select class="validity" placeholder="{{'signingTexts.Reminder' | translate}}"
                                        name="reminder-period" [ngModel]="reminder">
                                        <mat-option *ngFor="let p of periodsDictionary" (click)="onSelectReminderPeriod(p.value)"
                                            [value]="p.value">
                                            {{p.key}} {{getUnitTranslation(p.key, p.unit)}}
                                        </mat-option>
                                    </mat-select>
                                </div> -->
                        </div>
                    </mat-expansion-panel>

        
                    <div class="exapnd-wrapper" *ngFor="let receiver of sequences;let i=index">
                        <mat-expansion-panel *ngIf="receiver.documentDetails.length">
                            <mat-expansion-panel-header class="header-panel">
                                <mat-panel-title>
                                    <div class="container-header">
                                        <div class="receiver">{{ 'businessTexts.receiver' | translate
                                            }} <span>{{i+1}}</span> : {{getReceiverName(receiver)}}
                                        </div>
                                        <!-- <div class="icon-status">
                                            <cqes-icon matTooltip="{{getPackageIconTooltip() | translate}}"
                                                [icon]="getPackageIconName()" [iconClass]="getpackageIconClass()"></cqes-icon>
                                        </div> -->
                                        <div *ngIf="isDownloadAllAvailable(i)" class="icon-download">
                                            <button matTooltip="{{'historyTexts.downloadDocument' | translate}}"
                                                (click)="$event.stopPropagation();onDownloadAllDocuments(i)">
                                                <cqes-icon class="header-download" icon="file_download"></cqes-icon>
                                            </button>
                                        </div>
                                    </div>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <mat-table [dataSource]="receiver.documentDetails">
        
                                <ng-container matColumnDef="status">
                                    <mat-header-cell class="d-none d-sm-flex" *matHeaderCellDef>
                                        {{'historyTexts.documentStatus' | translate}} </mat-header-cell>
                                    <mat-cell class="tac d-none d-sm-flex" *matCellDef="let row"
                                        matTooltip="{{getIconTooltip(row) | translate}}">
                                        <cqes-icon [icon]="getIconName(row.status)"
                                            [iconClass]="getIconClass(row.status)"></cqes-icon>
                                    </mat-cell>
                                </ng-container>
        
                                <ng-container matColumnDef="filename">
                                    <mat-header-cell #filename class="d-block d-sm-flex" *matHeaderCellDef>
                                        {{'historyTexts.docName' | translate}} </mat-header-cell>
                                    <mat-cell class="d-block d-sm-flex" #el *matCellDef="let row" class="truncate" [matTooltip]="(el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight) ? row.filename : ''">
                                        {{row.filename}}
                                    </mat-cell>
                                </ng-container>
        
                                <ng-container matColumnDef="signable">
                                    <mat-header-cell class="d-block d-sm-flex" *matHeaderCellDef>
                                    </mat-header-cell>
                                    <mat-cell class="d-block d-lg-flex" *matCellDef="let row">
                                        <span *ngIf="!row.signable">{{ 'businessTexts.notToBeSigned' |
                                            translate }}</span>
                                    </mat-cell>
                                </ng-container>
        
                                <ng-container matColumnDef="sentTimestamp">
                                    <mat-header-cell #dsentTimestamp class="d-block d-sm-flex" *matHeaderCellDef>
                                        <span *ngIf="!isRegisteredDelivery(); else deliveredDate">
                                            {{ 'businessTexts.sentDate' | translate }}
                                          </span>
                                          <ng-template #deliveredDate>
                                            {{ 'businessTexts.deliveredDate' | translate }}
                                          </ng-template>
                                    </mat-header-cell>
                                    <mat-cell class="d-block d-sm-flex" *matCellDef="let row">
                                        {{row.ts | date: dateFormat}}<br>{{row.ts | date: timeFormat}}
                                    </mat-cell>
                                </ng-container>
        
                                <ng-container matColumnDef="deadlineTimestamp">
                                    <mat-header-cell #deadlineTimestamp class="d-block d-lg-flex" *matHeaderCellDef>
                                        {{'businessTexts.signDeadline'
                                        | translate}} </mat-header-cell>
                                    <mat-cell class="d-block d-lg-flex" *matCellDef="let row">
                                        {{row.validityTs
                                        | date: dateFormat}}<br>{{row.validityTs | date: timeFormat}}
                                    </mat-cell>
                                </ng-container>
        
                                <ng-container matColumnDef="signedTimestamp">
                                    <mat-header-cell #signedTimestamp class="d-block d-sm-flex" *matHeaderCellDef>
                                        {{'businessTexts.signedDate'
                                        | translate}} </mat-header-cell>
                                    <mat-cell class="d-block d-lg-flex" *matCellDef="let row">
                                        {{row.signatureTs
                                        | date: dateTimeFormat}} </mat-cell>
                                </ng-container>
        
                                <ng-container matColumnDef="actions">
                                    <mat-header-cell #actions class="d-block d-sm-flex" *matHeaderCellDef>
                                        {{'historyTexts.actions' | translate}}
                                    </mat-header-cell>
                                    <mat-cell class="d-block d-lg-flex" *matCellDef="let row">
                                        <span >
                                            <div>
                                                <span [matMenuTriggerFor]="actionsMenu">
                                                    <button mat-icon-button color="primary">
                                                        <cqes-icon icon="menu"></cqes-icon>
                                                    </button>
                                                </span>
                                                <mat-menu #actionsMenu [overlapTrigger]="false"
                                                    class="nav-responsive-overlay menu">
                                                    <button mat-menu-item *ngIf="isDownloadable(row.status)"
                                                        matTooltip="{{'businessTexts.downloadDocument' | translate}}"
                                                        (click)="onDownloadDocument(row)">
                                                        <cqes-icon icon="file_download"></cqes-icon>
                                                        {{'businessTexts.downloadDocument' | translate}}
                                                    </button>
                                                    <button mat-menu-item color="primary" *ngIf="row.archiveStatus === 'ARCHIVED'"
                                                        matTooltip="{{'businessTexts.simpleRecord' | translate}}"
                                                        (click)="onDownloadSimpleRecord(row)">
                                                        <cqes-icon icon="library_books"></cqes-icon>
                                                        {{'businessTexts.simpleRecord' | translate}}
                                                    </button>
                                                    <button mat-menu-item color="primary" *ngIf="row.archiveStatus === 'ARCHIVED'"
                                                        matTooltip="{{'businessTexts.detailedRecord' | translate}}"
                                                        (click)="onDownloadDetailedRecord(row)">
                                                        <cqes-icon icon="library_add"></cqes-icon>
                                                        {{'businessTexts.detailedRecord' | translate}}
                                                    </button>
                                                </mat-menu>
                                            </div>
                                        </span>
                                        <span *ngIf="isDownloadable(row.status)">
                                            <button matTooltip="{{'businessTexts.downloadDocument' | translate}}"
                                                (click)="onDownloadDocument(row)">
                                                <cqes-icon icon="file_download"></cqes-icon>
                                            </button>
                                        </span>
                                    </mat-cell>
                                </ng-container>
        
                                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                            </mat-table>
                        </mat-expansion-panel>
                        <div *ngIf="!receiver.documentDetails.length">
                            <div class="receiver-waiting">{{ 'businessTexts.receiver' | translate
                                }}&nbsp;<span>{{i+1}} </span>: {{getReceiverName(receiver)}}


                                <!-- <div class="icon-status">
                                    <cqes-icon matTooltip="{{getPackageIconTooltip() | translate}}"
                                        [icon]="getPackageIconName('IN_PROGRESS')"
                                        [iconClass]="getpackageIconClass('IN_PROGRESS')"></cqes-icon>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <div class="btn-wrapper">
                <button class="mat-mdc-raised-button action-button" (click)="closeDialog()">{{ 'close' | translate}}
                </button>
            </div>
        </mat-dialog-actions>
    </div>
</div>